import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import {reactive, ref} from "vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogDialog from "@/shared/ui/SogDialog.vue";
import {SogDialogButtons} from "@/shared/ui/types/SogDialogButtons";
import OrderHead from "@/shared/model/orderHead";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import Payment from "@/shared/model/Payment";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiOrder from "@/modules/Order/api";
import notificationService from "@/shared/services/NotificationService";

interface Props {
  orderHead?: OrderHead
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentDialogComponent',
  props: {
    orderHead: { default: undefined }
  },
  emits: ["okClicked"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const _items = reactive([{id: "Bank", value: "Überweisung"}, {id: "Cashbook", value: "Kassenbuch"}]);
const _selectedItem = ref("Bank");
const _bankInput = ref("")
const _noteInput = ref("")
const _date = ref(new Date())
const _paymentDialog = ref<InstanceType<typeof SogDialog> | null>(null)
const _spinner = useSpinner("main")


const props = __props
const emit = __emit

async function onOk() {
  const payment = new Payment();
  payment.date = _date.value;
  payment.paymentTypeId = _selectedItem.value;
  payment.bank = _bankInput.value;
  payment.memo = _noteInput.value;
  payment.orderId = props.orderHead?.id ?? "";
  _spinner.show()
  const res = await apiOrder.payRequest(payment)
  if (res) {
    notificationService.success("Bezahlung erfolgreich")
    onHide();
    emit("okClicked")
  }
  _spinner.hide();
}

function onHide() {
  _paymentDialog.value?.hide()
}


function showModal() {
  _paymentDialog.value?.show()
}

__expose({
  showModal
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogDialog, {
    id: "main",
    ref_key: "_paymentDialog",
    ref: _paymentDialog,
    target: "#app",
    "dialog-buttons": _unref(SogDialogButtons).OkCancel,
    onClickOk: onOk,
    onClickCancel: onHide
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Bezahlung", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", null, "Bezahlt am", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(SogDatePicker, {
                      modelValue: _date.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_date).value = $event)),
                      "value-type": "Date",
                      width: "270px"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("td", null, "Bezahlart", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(SogDropDownList, {
                      modelValue: _selectedItem.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_selectedItem).value = $event)),
                      "data-source": _items,
                      width: "100%"
                    }, null, 8, ["modelValue", "data-source"])
                  ])
                ]),
                _withDirectives(_createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", null, "Bank", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(SogTextBox, {
                      modelValue: _bankInput.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_bankInput).value = $event)),
                      width: "100%"
                    }, null, 8, ["modelValue"])
                  ])
                ], 512), [
                  [_vShow, _selectedItem.value === 'Bank']
                ]),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", null, "Hinweise", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(SogTextBox, {
                      modelValue: _noteInput.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_noteInput).value = $event)),
                      multiline: true,
                      width: "100%"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["dialog-buttons"]))
}
}

})